import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_select = _resolveComponent("q-select")!

  return (_openBlock(), _createBlock(_component_q_select, {
    filled: "",
    modelValue: _ctx.type,
    "onUpdate:modelValue": [
      _cache[0] || (_cache[0] = ($event: any) => ((_ctx.type) = $event)),
      _ctx.selectTurnType
    ],
    options: _ctx.types,
    label: "Tipo de Operación",
    dense: true,
    disable: _ctx.disable
  }, null, 8, ["modelValue", "options", "onUpdate:modelValue", "disable"]))
}